export default __webpack_public_path__ + "static/O0183-e5e8a8023683c16c370a3098c1c7f61b.png";